import { cardGroups } from './base-components/display/card-groups';
import { Card, ComponentMetadata, ComponentMetadataForEditing, DisplayCardEntry } from '@source-components-react/types';
import { componentNameToModifyAttribute } from './base-components/display/component-attributes/component-name-to-modify-attribute';
import { attributeListForComponentTypes } from './base-components/display/component-attributes/attribute-list-for-component-types';

let returnValue: ComponentMetadataForEditing | undefined;

// Flatten nested card groups and cards into a flat array of entries, then converts to a lookup map by entry ID
export const getComponentMetadataForEditing = () => {
  if (returnValue) {
    return returnValue;
  }
  const entries = cardGroups.flatMap(group => group.cards.flatMap((card: Card) => card.entries)) as DisplayCardEntry[];
  const componentMetadata: Record<string, ComponentMetadata> = entries.reduce(
    (acc, entry) => {
      acc[entry.id] = {
        defaultAttributeValues: entry.defaultAttributeValues,
        attributeEditModeConfigs: entry.attributeEditModeConfigs,
      };
      return acc;
    },
    {} as Record<string, ComponentMetadata>
  );
  returnValue = {
    attributeListForComponentTypes,
    componentNameToModifyAttribute,
    componentMetadata,
  };
  return returnValue;
};

